import { createReducer, on } from "@ngrx/store";
import {
  fetchCampaignAffiliates,
  fetchCampaignAffiliatesSuccess,
  fetchCampaignAffiliatesFailure,
  getCampaignAffiliate,
  getCampaignAffiliateFailure,
  getCampaignAffiliateSuccess,
  deleteCampaignAffiliate,
  deleteCampaignAffiliateSuccess,
  deleteCampaignAffiliateFailure,
  addCampaignAffiliate,
  addCampaignAffiliateSuccess,
  addCampaignAffiliateFailure,
  updateCampaignAffiliate,
  updateCampaignAffiliateSuccess,
  updateCampaignAffiliateFailure,
  fetchCampaignAffiliatesByComGroup,
  fetchCampaignAffiliatesByComGroupSuccess,
  fetchCampaignAffiliatesByComGroupFailure,
  unsubscribeCampaign,
  unsubscribeCampaignSuccess,
  unsubscribeCampaignFailure,
} from "./campaign-affiliates.action";

import { IState } from "@models/index";

const initialState: IState = {
  isLoaded: false,
  data: [],
  isSaved: false,
  selectedItem: {},
  error: null,
  total: 0,
  maxPages: 0,
  perPage: 0,
  currentPage: 0,
};

const _campaignAffiliateReducer = createReducer(
  initialState,
  on(fetchCampaignAffiliates, (state, { page, campaignID, filterOptions }) => {
    const payload = {
      isSaved: false,
    };

    return { ...state, ...payload };
  }),
  on(fetchCampaignAffiliatesSuccess, (state, { campaignAffiliates }) => {
    const payload = {
      isLoaded: true,
      data: campaignAffiliates.data,
      total: campaignAffiliates.total,
      maxPages: campaignAffiliates.maxPages,
      perPage: campaignAffiliates.perPage,
      currentPage: campaignAffiliates.currentPage,
      // selectedItem: {},
    };

    return { ...state, ...payload };
  }),
  on(fetchCampaignAffiliatesFailure, (state, { error }) => {
    const payload = {
      isLoaded: true,
      error,
    };
    return { ...state, ...payload };
  }),
  on(
    fetchCampaignAffiliatesByComGroup,
    (state, { page, campaignID, commissionGroupID }) => {
      const payload = {
        isLoaded: false,
        isSaved: false,
      };
      return { ...state, ...payload };
    }
  ),
  on(
    fetchCampaignAffiliatesByComGroupSuccess,
    (state, { campaignAffiliates }) => {
      const payload = {
        data: campaignAffiliates.data,
        total: campaignAffiliates.total,
        maxPages: campaignAffiliates.maxPages,
        perPage: campaignAffiliates.perPage,
        currentPage: campaignAffiliates.currentPage,
        // selectedItem: {},
        isLoaded: true,
      };

      return { ...state, ...payload };
    }
  ),
  on(fetchCampaignAffiliatesByComGroupFailure, (state, { error }) => {
    const payload = {
      error,
      isLoaded: true,
    };
    return { ...state, ...payload };
  }),
  on(getCampaignAffiliate, (state, { id }) => {
    const payload = {
      isSaved: false,
    };

    return { ...state, ...payload };
  }),
  on(getCampaignAffiliateSuccess, (state, { campaignAffiliate }) => {
    const payload = {
      selectedItem: campaignAffiliate,
    };
    return { ...state, ...payload };
  }),
  on(getCampaignAffiliateFailure, (state, { error }) => {
    const payload = {
      error,
    };
    return { ...state, ...payload };
  }),
  on(deleteCampaignAffiliate, (state, { id }) => {
    const payload = {
      isSaved: false,
    };

    return { ...state, ...payload };
  }),
  on(deleteCampaignAffiliateSuccess, (state, { id }) => {
    let total: number = state.total - 1;
    const payload = {
      isLoaded: true,
      total,
      data: state.data.filter((item) => item.id !== id),
    };
    return { ...state, ...payload };
  }),
  on(deleteCampaignAffiliateFailure, (state, { error }) => {
    const payload = {
      isLoaded: true,
      error,
    };
    return { ...state, ...payload };
  }),
  on(addCampaignAffiliate, (state, { campaignAffiliate }) => {
    const payload = {
      isSaved: false,
    };
    return { ...state, ...payload };
  }),
  on(addCampaignAffiliateSuccess, (state, { campaignAffiliate }) => {
    let total: number = state.total;
    if (state.total < state.perPage) {
      total += 1;
    } else {
      state.data.splice(state.data.length - 1, 1);
    }

    const payload = {
      total,
      isSaved: true,
      isLoaded: true,
      data: [{ ...campaignAffiliate }, ...state.data],
      selectedItem: campaignAffiliate,
    };
    return { ...state, ...payload };
  }),
  on(addCampaignAffiliateFailure, (state, { error }) => {
    const payload = {
      isSaved: false,
      isLoaded: true,
      error,
    };
    return { ...state, ...payload };
  }),
  on(updateCampaignAffiliate, (state, { campaignAffiliate }) => {
    const payload = {
      isSaved: false,
    };

    return { ...state, ...payload };
  }),
  on(updateCampaignAffiliateSuccess, (state, { campaignAffiliate }) => {
    const index = state.data.findIndex(
      (aff) => aff.id === campaignAffiliate.id
    );
    state.data[index] = campaignAffiliate;

    const payload = {
      isSaved: true,
      selectedItem: campaignAffiliate,
    };

    return { ...state, ...payload };
  }),
  on(updateCampaignAffiliateFailure, (state, { error }) => {
    const payload = {
      isSaved: false,
      error,
    };
    return { ...state, ...payload };
  }),
  on(unsubscribeCampaign, (state, { id }) => {
    const payload = {
      isSaved: false,
    };
    return { ...state, ...payload };
  }),
  on(unsubscribeCampaignSuccess, (state, { id }) => {
    const total: number = state.total - 1;
    const payload = {
      isLoaded: true,
      total,
      isSaved: true,
      selectedItem: {},
      data: state.data.filter((item) => item.id !== id),
    };
    return { ...state, ...payload };
  }),
  on(unsubscribeCampaignFailure, (state, { error }) => {
    const payload = {
      isLoaded: true,
      selectedItem: {},
      error,
    };
    return { ...state, ...payload };
  })
);

export function campaignAffiliateReducer(state, action) {
  return _campaignAffiliateReducer(state, action);
}
